import { ListItemIcon as DesignSystemListItemIcon } from '@uptime/design-system/components/ListItemIcon';
import { useThemeV7 } from '@uptime/design-system/MUIv7Exports';

interface Props {
  active?: boolean;
  children: React.ReactNode;
}

export const ListItemIcon = ({ children, active }: Props) => {
  const theme = useThemeV7();

  return (
    <DesignSystemListItemIcon
      sx={
        active
          ? {
              background: theme.palette.primary[500],
              color: theme.palette.grey.white,
            }
          : undefined
      }
    >
      {children}
    </DesignSystemListItemIcon>
  );
};
